import type { BannerIconConfig } from "@/features/auth/types/organization.type";
import { useBrandTheme } from "@/features/theme/hooks/useBrandTheme";

export const useBannerConfig = (pageKey?: string): BannerIconConfig | undefined => {
  const { brandTheme } = useBrandTheme();
  if (!pageKey) return undefined;
  return brandTheme?.banners?.[pageKey];
};
